import { IUser } from '@/models/user.model'
import { useAppDispatch } from '@/store/store'
import { resetUser } from '@/store/user'
import { Avatar } from '@nextui-org/react'
import { FC } from 'react'
import { HiOutlineLogout } from 'react-icons/hi'
import { useSelector } from 'react-redux'
import LogoTradein from '../../../../assets/images/LogoTradein.png'
import SucursalSwitcher from '../../../SucursalGate/SucursalSwitcher'
import './HeaderBackoffice.css'

const HeaderBackoffice: FC = () => {
  const dispatch = useAppDispatch()
  const userState = useSelector((store: { user: IUser }) => store.user)

  const now = new Date()
  // const hour = now.getHours()
  // const greeting = hour < 12 ? 'Buenos dias' : hour < 20 ? 'Buenas tardes' : 'Buenas noches'

  const dateStr = now.toLocaleDateString('es-CL', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  })

  return (
    <header className='header-backoffice'>
      <div className='header-backoffice-logo-area'>
        <img src={LogoTradein} alt='Trade-in' className='header-backoffice-logo' />
      </div>
      {/* <span className='header-backoffice-greeting'>{greeting}</span> */}
      <div className='header-backoffice-right'>
        <span className='header-backoffice-date'>{dateStr}</span>
        <div className='header-backoffice-user'>
          <Avatar name={userState.name?.[0]} className='bg-[#44526B] text-white font-bold text-sm' size='sm' />
          <div className='header-backoffice-user-info'>
            <span className='header-backoffice-user-name'>{userState.name}</span>
            <span className='header-backoffice-user-role'>{userState.name_role?.replace('TI_', '')}</span>
            {/* Solo WOM: sucursal activa de la sesión federada, con cambio en caliente
                cuando el usuario tiene más de una asignada. */}
            <SucursalSwitcher />
          </div>
        </div>
        <button
          type='button'
          onClick={() => dispatch(resetUser())}
          className='header-backoffice-logout'
          title='Cerrar sesión'
        >
          <HiOutlineLogout size={18} />
        </button>
      </div>
    </header>
  )
}

export default HeaderBackoffice
